import React from "react";
import { AlertTriangle } from "lucide-react";

export default function AIDisclaimer({ testid = "ai-disclaimer" }) {
  return (
    <div
      data-testid={testid}
      className="border border-yellow-400/60 bg-yellow-400/[0.06] px-4 py-3"
    >
      <div className="flex items-center gap-2 text-[10px] uppercase tracking-[0.2em] font-mono text-yellow-300">
        <AlertTriangle size={12} />
        AI_OUTPUT_DISCLAIMER · NOT_PROFESSIONAL_ADVICE
      </div>
      <p className="mt-1.5 text-[11.5px] leading-relaxed text-yellow-200/90">
        All responses on this site are generated by artificial intelligence and are
        provided for informational and research purposes only. Nothing here constitutes
        medical, legal, financial, tax, investment, or any other form of professional
        advice, and AI-generated content may contain errors, omissions, or outdated
        information. Always seek validation and guidance from a qualified professional
        — such as a licensed physician, attorney, or financial advisor — before acting
        on any output. By using this service you acknowledge that THE_MINDSTEIN and its
        operators accept no liability for decisions made in reliance on AI-generated
        content.
      </p>
    </div>
  );
}
